// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3PNi4","right":"styles_right__1dSWO"};